module.exports = __webpack_public_path__ + "static/media/CTLI_12-391w.f45764fd.jpg";